// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Specification-CareAndComposition-MainBaseCompositionData-module-addSalesRegionButton {
	min-width: 159px;
	position: relative;
	bottom: 3px;
}

.Specification-CareAndComposition-MainBaseCompositionData-module-cancelIcon { 
	color: var(--Grey800);
	height: 13.33px;
	width: 13.33px;
}

.Specification-CareAndComposition-MainBaseCompositionData-module-cancelIconButton { 
	height: 16px;
	width: 16px;
	margin-left: 4px;
}

.Specification-CareAndComposition-MainBaseCompositionData-module-tabCase {
	border-bottom: 1px solid var(--Grey400);
	height: 40px;
	padding: 15px 24px 0 24px;
}

.Specification-CareAndComposition-MainBaseCompositionData-module-tabMenu {
	border-bottom-width: 0;
	-ms-flex-positive: 1;
	    flex-grow: 1;
	width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Specification/CareAndComposition/MainBaseCompositionData.module.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,uCAAuC;CACvC,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;CACtB,oBAAY;KAAZ,YAAY;CACZ,WAAW;AACZ","sourcesContent":[".addSalesRegionButton {\n\tmin-width: 159px;\n\tposition: relative;\n\tbottom: 3px;\n}\n\n.cancelIcon { \n\tcolor: var(--Grey800);\n\theight: 13.33px;\n\twidth: 13.33px;\n}\n\n.cancelIconButton { \n\theight: 16px;\n\twidth: 16px;\n\tmargin-left: 4px;\n}\n\n.tabCase {\n\tborder-bottom: 1px solid var(--Grey400);\n\theight: 40px;\n\tpadding: 15px 24px 0 24px;\n}\n\n.tabMenu {\n\tborder-bottom-width: 0;\n\tflex-grow: 1;\n\twidth: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addSalesRegionButton": `Specification-CareAndComposition-MainBaseCompositionData-module-addSalesRegionButton`,
	"cancelIcon": `Specification-CareAndComposition-MainBaseCompositionData-module-cancelIcon`,
	"cancelIconButton": `Specification-CareAndComposition-MainBaseCompositionData-module-cancelIconButton`,
	"tabCase": `Specification-CareAndComposition-MainBaseCompositionData-module-tabCase`,
	"tabMenu": `Specification-CareAndComposition-MainBaseCompositionData-module-tabMenu`
};
module.exports = ___CSS_LOADER_EXPORT___;
